import rewind from "../assets/images/contributedBlogs/rewind.svg";
import codecov from "../assets/images/contributedBlogs/codecov.svg";
import thenewstack from "../assets/images/contributedBlogs/thenewstack.svg";
import replit from "../assets/images/contributedBlogs/replit.png";
import sectionio from "../assets/images/contributedBlogs/sectionio.svg";
import draftdev from "../assets/images/contributedBlogs/draftdev.png";
import influxdata from "../assets/images/contributedBlogs/influxdata.svg";
import tds from "../assets/images/contributedBlogs/tds.jpeg";
import bp from "../assets/images/contributedBlogs/bp.png";

export const contributedBlogs = {
  blogs: [
    {
      image: rewind,
      url: "https://rewind.com/blog/using-bitbucket-api/",
      name: "Rewind",
    },
    {
      image: codecov,
      url: "https://about.codecov.io/blog/writing-better-tests-with-ai-and-github-copilot/",
      name: "CodeCov",
    },
    {
      image: thenewstack,
      url: "https://thenewstack.io/getting-started-with-python-and-influxdb/",
      name: "The New Stack",
    },
    {
      image: replit,
      url: "https://blog.replit.com/build-your-own-livestreaming-service-with-api-video",
      name: "Replit",
    },
    {
      image: sectionio,
      url: "https://www.section.io/engineering-education/authors/rahul-banerjee/",
      name: "Section.io",
    },
    {
      image: influxdata,
      url: "https://www.influxdata.com/blog/start-python-influxdb/",
      name: "InfluxData",
    },
    {
      image: tds,
      url: "https://medium.com/towards-data-science/advanced-sql-going-beyond-the-basics-bbcae047fe7e",
      name: "Towards Data Science",
    },
    {
      image: bp,
      url: "https://medium.com/better-programming/how-to-make-an-ai-assisted-phone-service-with-twilio-98c6d0425a8d",
      name: "Better Programming",
    },
    {
      image: draftdev,
      url: "https://portal.draft.dev/writers/recwGa0upzWgR7IDq",
      name: "Draft.Dev",
    },
  ],
};

export const realPythonProject = {
  name: "Real Python Project",
  url: "https://www.realpythonproject.com",
};

export const realJavaScriptProject = {
  name: "Real JavaScript Project",
  url: "https://www.realjavascriptproject.com",
};

export const crossPostBlogs = {
  blogs: [
    {
      name: "Medium",
      followers: "600+",
      views: "300k+",
      profileURL: "https://rahul1999.medium.com/",
    },
    {
      name: "Dev.to",
      followers: "900+",
      views: "39k+",
      profileURL: "https://dev.to/rahulbanerjee99",
    },
    {
      name: "Hashnode",
      followers: "60+",
      profileURL: "https://hashnode.com/@rahul2699",
      views: "13k+",
    },
  ],
};
